import React, { useState, useEffect } from 'react';
import PartFirstTab from './components/PartFirstTab';
import PartSecondTab from './components/PartSecondTab';
import PartThirdTab from './components/PartThirdTab';
import PartFourTab from './components/PartFourTab';
import Header from '../../components/Header';
import TabScrollButton from '@mui/material/TabScrollButton';
import { MdArrowUpward } from 'react-icons/md'; // Import the scroll-to-top icon
import TextField from '@mui/material/TextField';
import { ToastContainer, toast } from 'react-toastify';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';


import "./stepper.css";
import { TiTick } from "react-icons/ti";
import AlertDialogSlide from './components/modal/AlertDialogSlide';
import Footer from '../../components/Footer';

const TOAST_ID = 'toast-unique-id';
const MainModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);



  const [open, setOpen] = useState(false);
  const [error, setError] = useState('');
  const [name, setName] = useState('');
  const [age, setAge] = useState('');
  const [course, setCourse] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] =useState('');
  const [collegeName, setCollegeName ] =useState('');
  const [schoolName, setSchoolName ] =useState('');
  const [grade, setGrade] =useState('');
  const [section, setSection] =useState('');
  const [companyName, setCompanyName] =useState('');
  const [role, setRole] =useState('');
  const [edu, setEdu]=useState('');



  const steps = ["Part I", "Part II", "Part III", "Part IV"];
const [emailError, setEmailError] =useState('');
const [nameError, setNameError] = useState('');
const [ageError, setAgeError]= useState('');
const [courseError, setCourseError] =useState('');
const [phoneError, setPhoneError] =useState('');
const [gradeError, setGradeError] =useState('');
const [sectionError, setSectionError] =useState('');
const [companyNameError, setCompanyNameError] =useState('');
const [roleError, setRoleError] =useState('');
const [eduError, setEduError] =useState('');


  const [selectedOption, setSelectedOption] = useState(''); // Default value



  const [selectedAnswersPartI, setSelectedAnswersPartI] = useState({});
  const [selectedAnswersPartII, setSelectedAnswersPartII] = useState({});
  const [selectedAnswersPartIII, setSelectedAnswersPartIII] = useState([]);
  const [selectedAnswersPartIV, setSelectedAnswersPartIV] = useState({});


  

  const partIVQuestions = [
    { id: 93, text: "Challenging myself to achieve", n: 1 },
    { id: 94, text: "Being liked by others", n: 2 },
    { id: 96, text: "Being sensitive to others’ needs", n: 3 },
    { id: 95, text: "Protecting the environment", n: 4 },
    { id: 111, text: "Creating new things or ideas", n: 5 },
    { id: 108, text: "Being accepted by others", n: 6 },
    { id: 109, text: "Taking care of the environment", n: 7 },
    { id: 107, text: "Improving my performance", n: 8 },
    { id: 110, text: "Helping others", n: 9 },
    { id: 106, text: "Believing in a higher power", n: 10 },
    { id: 121, text: "Working hard to do better", n: 11 },
    { id: 113, text: "Being in good physical shape", n: 12 },
    { id: 112, text: "Making money", n: 13 },
    { id: 123, text: "Appreciating the beauty of nature", n: 14 },
    { id: 129, text: "Having control over my time", n: 15 },
    { id: 131, text: "Having a private place to go", n: 16 },
    { id: 122, text: "Feeling as though I belong", n: 17 },
    { id: 132, text: "Meeting my obligations", n: 18 },
    { id: 116, text: "Respecting the traditions of my family or group", n: 19 },
    { id: 130, text: "Making decisions with my family or group in mind", n: 20 },
    { id: 133, text: "Knowing about math", n: 21 },
    { id: 134, text: "Living in harmony with my spiritual beliefs", n: 22 },
    { id: 128, text: "Avoid credit for my accomplishments", n: 23 },
    { id: 124, text: "Being concerned about the rights of others", n: 24 },
    { id: 99, text: "Taking care of my body", n: 25 },
    { id: 117, text: "Having quiet time to think", n: 26 },
    { id: 127, text: "Being strong or good in a sport (being athletic)", n: 27 },
    { id: 126, text: "Being wealthy (having lots of money, land or livestock)", n: 28 },
    { id: 119, text: "Knowing things about science", n: 29 },
    { id: 118, text: "Being trustworthy", n: 30 },
    { id: 120, text: "Believing that there is something greater than ourselves", n: 31 },
    { id: 114, text: "Being quiet about my success", n: 32 },
    { id: 125, text: "Discovering new things or ideas", n: 33 },
    { id: 105, text: "Using science for progress", n: 34 },
    { id: 102, text: "Accepting my place in my family or group", n: 35 },
    { id: 104, text: "Being reliable", n: 36 },
    { id: 115, text: "Giving my opinion", n: 37 },
    { id: 98, text: "Having financial success", n: 38 },
    { id: 101, text: "Being independent (doing things I want to do)", n: 39 },
    { id: 103, text: "Having time to myself", n: 40 },
    { id: 100, text: "Downplaying compliments or praise", n: 41 },
    { id: 97, text: "Coming up with new ideas", n: 42 }
  ];

  useEffect(() => {
    if (Object.keys(selectedAnswersPartIV).length === 0) {
      const defaultAnswers = partIVQuestions.reduce((acc, question) => {
        acc[question.id] = 1; 
        return acc;
      }, {});
      setSelectedAnswersPartIV(defaultAnswers);
    }
  }, [selectedAnswersPartIV, setSelectedAnswersPartIV]);




  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };


  const formattedData = {
    value: {
      ...selectedAnswersPartIV,
    },
    interest: selectedAnswersPartIII.map(String),
    personality: [
      ...Object.entries(selectedAnswersPartI).flatMap(([key, value]) => {
        if (Array.isArray(value)) {
          // If the value is an array (e.g., for question 25), return each selection separately
          return value.map((v) => `${key}${v}`);
        }
        // Otherwise, handle as a single value
        return `${key}${value}`;
      }),
      ...Object.entries(selectedAnswersPartII).map(([key, value]) => `${key}${value}`),
    ],
  };


  




  
  
  useEffect(() => {
    setIsModalOpen(true);
  }, []);


  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isModalOpen]);



  const closeModal = () => {
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if(!name || !age || !phone || !email || !emailRegex.test(email) || phone.length !== 10 ){
      if (!name) {
      setNameError("Mandatory Field.");
      }

      if( !age){

      setAgeError("Mandatory Field.");
      }
     if( !email) {

      setEmailError("Mandatory Field.");
    }else{
      if ( !emailRegex.test(email)) {
        setEmailError("Enter a valid email address");
        
      }
    
    }
    
    
    if(!phone){
      setPhoneError("Mandatory Field.");
    } else{

    if (phone.length !== 10) {
      setPhoneError("Enter 10-digit phone number");
    }
  } return;

}

   
if(selectedOption === ''){
  return;
}
     


    if(selectedOption==='SCHOOL'){
      if(!grade || !section){
        if(!grade){
          setGradeError("Mandatory Field")

        }
        if(!section){
          setSectionError("Mandatory Field")
        }
        return; 
      }
      
    }

    if(selectedOption==='COLLEGE'){
      if(!course ){
        
          setCourseError("Mandatory Field")

        
          return;

      }
      
    }
    if(selectedOption==='PROFESSIONAL'){
      if(!companyName || !role ||!edu){
        if(!companyName){
          setCompanyNameError("Mandatory Field")

        }
        if(!role){
          setRoleError("Mandatory Field")
        }

        if(!edu){
          setEduError("Mandatory Field")
        }
        
        return;
      }
      
    }
  
    






    setIsModalOpen(false);


    

  
    

  };



  const handleNext = () => {
    if (currentStep < steps.length) {
      setCurrentStep((prev) => prev + 1);
    } else {
      setComplete(true); // Mark the stepper as complete
    }
  };

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const handleStepClick = (step) => {

    setCurrentStep(step);
  };


  const handleRadioChange =(event)=>{
    setSelectedOption(event.target.value);
    
  }



  const handleSubmitModal = () => {
    setOpen(true);
  }


  const [currentStep, setCurrentStep] = useState(1);
  const [complete, setComplete] = useState(false);
  return (
    <>

    <Header  userName="" />
    <ToastContainer />
      <div className=" bg-gray-100 mb-10">

      <div className="stepper-container bg-gray-100">
  <div className="stepper-content">
    <div className="flex justify-between flex-wrap">
      {steps.map((step, i) => (
        <div
          key={i}
          className={`cursor-pointer step-item ${currentStep === i + 1 && "active"} ${(i + 1 < currentStep || complete) && "complete"}`}
          onClick={() => handleStepClick(i + 1)} // Handle click on step item
        >
          <div className="step">
            {i + 1 < currentStep || complete ? <TiTick size={24} /> : i + 1}
          </div>
          <p className="text-gray-500">{step}</p>
        </div>
      ))}
    </div>
    <div>
    <button
      type="button"
      onClick={handleSubmitModal}
      className=" res-button cursor-pointer submit-btn">
      Submit Test
    </button>
    </div>
  </div>
</div>


        {/* Render the content for each step */}
        <div className="bg-gray-100  " style={{ marginTop: "160px" }}>
          {currentStep === 1 && <PartFirstTab selectedAnswersPartI={selectedAnswersPartI}
            setSelectedAnswersPartI={setSelectedAnswersPartI} />}
          {currentStep === 2 && <PartSecondTab selectedAnswersPartII={selectedAnswersPartII}
            setSelectedAnswersPartII={setSelectedAnswersPartII} />}
          {currentStep === 3 && <PartThirdTab selectedAnswersPartIII={selectedAnswersPartIII}
            setSelectedAnswersPartIII={setSelectedAnswersPartIII} />}
          {currentStep === 4 && <PartFourTab questions={partIVQuestions} selectedAnswersPartIV={selectedAnswersPartIV}
            setSelectedAnswersPartIV={setSelectedAnswersPartIV} />}
        </div>
<div>
    
</div>


                {/* Scroll to Top Button */}
                {showScrollTop && (
          <button
            onClick={handleScrollToTop}
            className=" p-4 scroll-to-top-button fixed bottom-20 right-8 bg-blue-500 text-white text-center rounded-full shadow-lg hover:bg-blue-600 transition"
          >
                        <MdArrowUpward size={24} />

          </button>
        )}


        {/* Back and Next buttons */}
        <div className=" container bg-gray-100 mx-auto justify-center items-center px-6 ">
          <div className="flex parts pl-24 pr-24 justify-between items-center pb-10" >
            <button
              onClick={handleBack}
              className={`btn  text-gray-700 px-4 py-2 rounded ${currentStep === 1 ? " bg-gray-200 opacity-50 cursor-not-allowed" : "bg-blue-500 text-white"}`}
              disabled={currentStep === 1}
            >
              Back
            </button>
            <button
              onClick={currentStep === steps.length ? handleSubmitModal : handleNext}
              className="btn bg-blue-500 text-white px-4 py-2 rounded"
            >
              {currentStep === steps.length ? "Finish" : "Next"}
            </button>
          </div>
        </div>




        <
          AlertDialogSlide
          open={open} setOpen={setOpen} name={name} age={age} course={course} email={email} 
          phone ={phone}
          selectedOption ={selectedOption}
          collegeName={collegeName}
          grade={grade}
          section={section}
          schoolName={schoolName}
          companyName={companyName}
          role={role}
          edu={edu}
          
          
          
          formattedData={formattedData} error={error} setError={setError} 
          selectedAnswersPartI ={selectedAnswersPartI}
          selectedAnswersPartII = {selectedAnswersPartII}
          selectedAnswersPartIII = {selectedAnswersPartIII}
          
          />
        {isModalOpen && (
          <div>
            <div
              className="fixed modal inset-0 flex items-center justify-center bg-gray-400 backdrop-blur-sm bg-opacity-10"
            >
              <div className={` modal-main w-[600px] mx-auto bg-white  pb-4 rounded-md shadow-lg ${!selectedOption ? 'modal-option-not':''}`}
                style={{
                  backgroundColor: 'white',
                
                  border: '1px solid #e0e0e0',
                  


                }}
              >

                <div className=" pl-6 pt-2 pb-2 flex justify-between items-center mb-1"
                  style={{
                    backgroundColor: '#Ffc71a',

                  }}><div className="modal-header"
                    >
                    Personal Details
                  </div>

                </div>
                
                <div className="modal-content modal-grid pl-12 pt-8 pr-12 gap-4 grid grid-cols-2">
                  <div className="pb-1">
                    <label className="modal-label block text-lg font-medium" style={{
                      fontSize: "1.25rem", fontWeight: "500", color: "gray-200",
                    }}>
                      <span>
                        Name
                        <span className="pl-1 text-red-600">*</span>

                      </span>
                    </label>
                

                  <TextField
  error={!!nameError} // Error prop triggers error styles
  id="outlined-error"
  placeholder={nameError ? "Mandatory field" : "Enter Name"}
  value={name}
  onChange={(e) => {
    const value = e.target.value;
    if (/^[A-Za-z\s]*$/.test(value) || value === '') {
      setName(value);
    }
    setNameError(''); // Clear error on valid input
  }}
  variant="outlined"
  fullWidth
  inputProps={{
    style: {
      fontSize: "1rem", // Font size for the input
      padding: "16px 12px" // Padding for better appearance
    }
  }}
  FormHelperTextProps={{
    style: { fontSize: "0.875rem" } // Custom styles for helper text
  }}
  sx={{
    "& .MuiOutlinedInput-root": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: nameError ? "red" : "#A0A0A0", // Border color on error
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: nameError ? "red" : "black", // Hover border color
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: nameError ? "red" : "black", // Focus border color
      }
    },
    "& .MuiInputLabel-root": {
      color: nameError ? "red" : "#A0A0A0", // Label color based on error
      "&.Mui-focused": {
        color: nameError ? "red" : "black" // Focused label color
      }
    }
  }}
/>

                  </div>

              


                
                  <div>
                    <label className="block text-lg font-medium" style={{
                      fontSize: "1.25rem", fontWeight: "500", color: "gray-200",
                    }}>
                      <span>
                        Age
                        <span className="pl-1 text-red-600">*</span>

                      </span>
                    </label>
                  
                  <TextField
  error={!!ageError} // Error prop triggers error styles
  id="outlined-error"
  placeholder={ageError ? "Mandatory field" : "Enter Age"} // Dynamic label based on error
  value={age}
  onChange={(e) => {
    const value = e.target.value;
    if (/^[0-9\s]*$/.test(value) || value === '') {
      setAge(value);
    }
    setAgeError(''); // Clear error on valid input
  }}
  variant="outlined"
  fullWidth
  inputProps={{
    style: {
      fontSize: "1rem", // Font size for the input
      padding: "16px 12px" // Padding for better appearance
    }
  }}
  FormHelperTextProps={{
    style: { fontSize: "0.875rem" } // Custom styles for helper text
  }}
  sx={{
    "& .MuiOutlinedInput-root": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: ageError ? "red" : "#A0A0A0", // Border color on error
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: ageError ? "red" : "black", // Hover border color
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: ageError ? "red" : "black", // Focus border color
      }
    },
    "& .MuiInputLabel-root": {
      color: ageError ? "red" : "A0A0A0", // Label color based on error
      "&.Mui-focused": {
        color: ageError ? "red" : "black" // Focused label color
      }
    }
  }}
/>


                  </div>

                </div>


                <div className="modal-content modal-grid pl-12 pt-6 pr-12 gap-4 grid grid-cols-2">


                  <div className='pb-1'>
                    <label className="block text-lg font-medium" style={{
                      fontSize: "1.25rem", fontWeight: "500", color: "gray-200",
                    }}>
                      <span>
                        Phone No.
                        <span className="pl-1 text-red-600">*</span>

                      </span>
                    </label>
                  <TextField
  error={!!phoneError} // Error prop triggers error styles
  id="outlined-error"
  placeholder={phoneError ? `${phoneError}` : "Enter Phone No."} // Dynamic label based on error
  value={phoneError? '' : phone}
  onChange={(e) => {
    const value = e.target.value;
    if (/^[0-9\s]*$/.test(value) || value === '') {
      setPhone(value);
    }
    setPhoneError(''); // Clear error on valid input
  }}
  variant="outlined"
  fullWidth
  inputProps={{
    style: {
      fontSize: "1rem", // Font size for the input
      padding: "16px 12px" // Padding for better appearance
    }
  }}
  FormHelperTextProps={{
    style: { fontSize: "0.875rem" } // Custom styles for helper text
  }}
  sx={{
    "& .MuiOutlinedInput-root": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: phoneError ? "red" : "#A0A0A0", // Border color on error
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: phoneError ? "red" : "black", // Hover border color
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: phoneError ? "red" : "black", // Focus border color
      }
    },
    "& .MuiInputLabel-root": {
      color: phoneError ? "red" : "#A0A0A0", // Label color based on error
      "&.Mui-focused": {
        color: phoneError ? "red" : "black" // Focused label color
      }
    }
  }}
/>


                  </div>

                  <div>
                    <label className="block text-lg font-medium" style={{
                      fontSize: "1.25rem", fontWeight: "500", color: "gray-200"
                    }}>
                      <span>
                        Email
                        <span className="pl-1 text-red-600">*</span>

                      </span>
                    </label>
                  
                  <TextField
  error={!!emailError} // Error prop triggers error styles
  id="outlined-error"
  placeholder={emailError ? `${emailError}` : "Enter Email"} // Dynamic label based on error
  value={emailError ? '':email}
  onChange={(e) => {
    const value = e.target.value;
    
      setEmail(value);
    
    setEmailError(''); // Clear error on valid input
  }}
  variant="outlined"
  fullWidth
  inputProps={{
    style: {
      fontSize: "1rem", // Font size for the input
      padding: "16px 12px" // Padding for better appearance
    }
  }}
  FormHelperTextProps={{
    style: { fontSize: "0.875rem" } // Custom styles for helper text
  }}
  sx={{
    "& .MuiOutlinedInput-root": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: emailError ? "red" : "#A0A0A0", // Border color on error
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: emailError ? "red" : "black", // Hover border color
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: emailError ? "red" : "black", // Focus border color
      }
    },
    "& .MuiInputLabel-root": {
      color: emailError ? "red" : "#A0A0A0", // Label color based on error
      "&.Mui-focused": {
        color: emailError ? "red" : "black" // Focused label color
      }
    }
  }}
/>


                  </div>



                </div>
                <div className=" pl-16 pr-16 pt-4 modal-content modal-radio"
      style={{
        
        display: 'flex',
        alignItems: 'center', // Keep items aligned vertically
        '@media (max-width: 1200px)': {
          padding: '1rem 2rem', // Adjust padding for smaller screens
        },
        '@media (max-width: 400px)': {
          
        },
      }}
    >
      <RadioGroup
        className="responsive-radio-group"
        row // Ensures the radio buttons stay in a horizontal row layout
        aria-labelledby="demo-radio-buttons-group-label"
        name="radio-buttons-group"
        onChange={handleRadioChange}
        sx={{
          gap: 6, // Default gap between radio buttons
          display: 'flex', // Ensure flexbox display
          flexWrap: 'nowrap', // Prevent wrapping (keep all buttons in a row)
          
          '@media (max-width: 1200px)': {
            gap: '15px', 
          },
          '@media (max-width: 400px)': {
            gap: '4px', 
          },
        }}
      >
        <FormControlLabel
          value="COLLEGE"
          control={<Radio />}
          label={
            <span>
              College<span style={{ color: 'red' }}>*</span>
            </span>
          }
      
          
          sx={{
            
      
            '& .MuiFormControlLabel-label': {
              fontSize: '1.25rem',
              fontWeight: '500',

              '@media (max-width: 1200px)': {
                fontSize: '1rem',
              },

              '@media (max-width: 400px)': {
                fontSize: '16px', // Smaller font size for medium screens
                fontWeight:"300",
                marginLeft:"0px",
                
                
              },
               
            },

            '& .MuiRadio-root': {
            '@media (max-width: 1200px)': {
              
              paddingRight: '2px',
            },
            '@media (max-width: 400px)': {
              fontSize:"0.5rem",
              paddingRight: '1px',
            },
          }
          }}
        />




        <FormControlLabel
          value="SCHOOL"
          control={<Radio />}
          label={
            <span>
              School<span style={{ color: 'red', marginLeft: '1px' }}>*</span>
            </span>
          }
      
          sx={{
            '& .MuiFormControlLabel-label': {
              fontSize: '1.25rem',
              fontWeight: '500',
              '@media (max-width: 1200px)': {
                fontSize: '1rem',
              },
              
              '@media (max-width: 400px)': {
                fontSize: '16px', // Smaller font size for medium screens
                fontWeight:"300"
                
                
              },

            },
            
            '& .MuiRadio-root': {
              '@media (max-width: 1200px)': {
                
                paddingRight: '2px',
              },
              '@media (max-width: 400px)': {
                
                paddingRight: '1px',
              },
            }
  
          }}
        />
        <FormControlLabel
          value="PROFESSIONAL"
          control={<Radio />}
          label={
            <span>
              Professional<span style={{ color: 'red', marginLeft: '1px' }}>*</span>
            </span>
          }
      
          sx={{
            '& .MuiFormControlLabel-label': {
              fontSize: '1.25rem',
              fontWeight: '500',
              '@media (max-width: 1200px)': {
                fontSize: '1rem',
              },
              '@media (max-width: 400px)': {
                fontSize: '16px',
                fontWeight:"300"
              },
            },
              
            '& .MuiRadio-root': {
              fontSize:"4px",
              '@media (max-width: 1200px)': {
                
                paddingRight: '2px',
              },
              '@media (max-width: 400px)': {
                
                paddingRight: '1px',
              },
            }
  
            
          }}
        />
      </RadioGroup>
    </div>
  



<div className="tabs mt-6 pl-12 pr-12">
{selectedOption === 'COLLEGE' && (
  <>
          
            <div className="modal-content  pl-grid modal-tabs-grid grid grid-cols-2">


                  <div className=''>
                    <label className="block text-lg font-medium" style={{
                      fontSize: "1.25rem", fontWeight: "500", color: "gray-200",
                    }}>
                      <span>
                        Course
                        <span className="pl-1 text-red-600">*</span>

                              </span>
                            </label>
                          <TextField
          error={!!courseError} // Error prop triggers error styles
          id="outlined-error"
          placeholder={courseError ? "Mandatory field" : "Enter Course"} // Dynamic label based on error
          value={course}
          onChange={(e) => {
            const value = e.target.value;
              setCourse(value);
            
            setCourseError(''); // Clear error on valid input
          }}
          variant="outlined"
          fullWidth
          inputProps={{
            style: {
              fontSize: "1rem", // Font size for the input
              padding: "16px 12px" // Padding for better appearance
            }
          }}
          FormHelperTextProps={{
            style: { fontSize: "0.875rem" } // Custom styles for helper text
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: courseError ? "red" : "#A0A0A0", // Border color on error
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: courseError ? "red" : "black", // Hover border color
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: courseError ? "red" : "black", // Focus border color
              }
            },
            "& .MuiInputLabel-root": {
              color: courseError ? "red" : "#A0A0A0", // Label color based on error
              "&.Mui-focused": {
                color: courseError ? "red" : "black" // Focused label color
              }
            }
          }}
        />


                          </div>


        <div>

          <label className="block text-lg font-medium" style={{
            fontSize: "1.25rem", fontWeight: "500", color: "gray-200", 
          }}>
            
            <span>
              College

            </span>
            </label>

        <TextField
        
        
        placeholder={"Enter College Name"} // Dynamic label based on error
        value={collegeName}
        onChange={(e) => {
        const value = e.target.value;

        setCollegeName(value);
        }}
        variant="outlined"
        fullWidth
        inputProps={{
        style: {
        fontSize: "1rem", // Font size for the input
        padding: "16px 12px" // Padding for better appearance
        }
        }}
        FormHelperTextProps={{
        style: { fontSize: "0.875rem" } // Custom styles for helper text
        }}
        sx={{
        "& .MuiOutlinedInput-root": {
        "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#A0A0A0", // Border color on error
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "black", // Hover border color
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "black", // Focus border color
        }
        },
        "& .MuiInputLabel-root": {
        color:  "#A0A0A0", // Label color based on error
        "&.Mui-focused": {
        color: "black" // Focused label color
        }
        }
        }}
        />


        </div>
        </div>
        


</>
            
          
        )}
        {selectedOption === 'SCHOOL' && (
          <>
           <div className="modal-content gap-4 grid grid-cols-2 tabs-ygap">


                      <div className=''>
                        <label className="block text-lg font-medium" style={{
                          fontSize: "1.25rem", fontWeight: "500", color: "gray-200", 
                        }}>
                          <span>
                            Grade
                            <span className="pl-1 text-red-600">*</span>

                          </span>
                        </label>
                      <TextField
            error={!!gradeError} // Error prop triggers error styles
            id="outlined-error"
            placeholder={gradeError ? "Mandatory field" : "Enter Grade"} // Dynamic label based on error
            value={grade}
            onChange={(e) => {
            const value = e.target.value;
            if (/^[0-9\s]*$/.test(value) || value === '') {
            setGrade(value);
            }
            setGradeError(''); // Clear error on valid input
            }}
            variant="outlined"
            fullWidth
            inputProps={{
            style: {
            fontSize: "1rem", // Font size for the input
            padding: "16px 12px" // Padding for better appearance
            }
            }}
            FormHelperTextProps={{
            style: { fontSize: "0.875rem" } // Custom styles for helper text
            }}
            sx={{
            "& .MuiOutlinedInput-root": {
            "& .MuiOutlinedInput-notchedOutline": {
            borderColor: gradeError ? "red" : "#A0A0A0", // Border color on error
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: gradeError ? "red" : "black", // Hover border color
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: gradeError ? "red" : "black", // Focus border color
            }
            },
            "& .MuiInputLabel-root": {
            color: gradeError ? "red" : "#A0A0A0", // Label color based on error
            "&.Mui-focused": {
            color: gradeError ? "red" : "black" // Focused label color
            }
            }
            }}
            />


                      </div>

                      <div>
                        <label className="block text-lg font-medium" style={{
                          fontSize: "1.25rem", fontWeight: "500", color: "gray-200"
                        }}>
                          <span>
                            Section
                            <span className="pl-1 text-red-600">*</span>

                          </span>
                        </label>
                      
                      <TextField
            error={!!sectionError} // Error prop triggers error styles
            id="outlined-error"
            placeholder={sectionError ? "Mandatory field" : "Enter Section"} // Dynamic label based on error
            value={section}
            onChange={(e) => {
            const value = e.target.value;

            setSection(value);

            setSectionError(''); // Clear error on valid input
            }}
            variant="outlined"
            fullWidth
            inputProps={{
            style: {
            fontSize: "1rem", // Font size for the input
            padding: "16px 12px", // Padding for better appearance,
            
            }
            }}
            FormHelperTextProps={{
            style: { fontSize: "0.875rem" } // Custom styles for helper text
            }}
            sx={{
            "& .MuiOutlinedInput-root": {
            "& .MuiOutlinedInput-notchedOutline": {
            borderColor: sectionError ? "red" : "#A0A0A0", // Border color on error
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: sectionError ? "red" : "black", // Hover border color
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: sectionError ? "red" : "black", // Focus border color
            }
            },
            "& .MuiInputLabel-root": {
            color: sectionError ? "red" : "#A0A0A0", // Label color based on error
            "&.Mui-focused": {
            color: sectionError ? "red" : "black" // Focused label color
            }
            }
            }}
            />


                      </div>



                    </div>


                    <div className="modal-content mt-2 gap-2 grid grid-cols-1">

<div>

  <label className="block text-lg font-medium" style={{
    fontSize: "1.25rem", fontWeight: "500", color: "gray-200",
  }}>
    
    <span>
      School

    </span>
    </label>

    



<TextField


placeholder={"Enter School Name"} // Dynamic label based on error
value={schoolName}
onChange={(e) => {
const value = e.target.value;

setSchoolName(value);
}}
variant="outlined"
fullWidth
inputProps={{
style: {
fontSize: "1rem", // Font size for the input
padding: "16px 12px" // Padding for better appearance
}
}}
FormHelperTextProps={{
style: { fontSize: "0.875rem" } // Custom styles for helper text
}}
sx={{
"& .MuiOutlinedInput-root": {
"& .MuiOutlinedInput-notchedOutline": {
borderColor: "#A0A0A0", // Border color on error
},
"&:hover .MuiOutlinedInput-notchedOutline": {
borderColor: "black", // Hover border color
},
"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
borderColor: "black", // Focus border color
}
},
"& .MuiInputLabel-root": {
color:  "#A0A0A0", // Label color based on error
"&.Mui-focused": {
color: "black" // Focused label color
}
}
}}
/>


</div>
</div>



</>          
        )}
        {selectedOption === 'PROFESSIONAL' && (
          
          <>
          <div className="modal-content gap-4 grid grid-cols-2">


                     <div>
                       <label className="block text-lg font-medium" style={{
                         fontSize: "1.25rem", fontWeight: "500", color: "gray-200",
                       }}>
                         <span>
                           Company
                           <span className="pl-1 text-red-600">*</span>

                         </span>
                       </label>
                     <TextField
           error={!!companyNameError} // Error prop triggers error styles
           id="outlined-error"
           placeholder={companyNameError ? "Mandatory field" : "Enter Company Name"} // Dynamic label based on error
           value={companyName}
           onChange={(e) => {
           const value = e.target.value;
           
           setCompanyName(value);
           
           setCompanyNameError(''); // Clear error on valid input
           }}
           variant="outlined"
           fullWidth
           inputProps={{
            className:"text-field",
           style: {
           fontSize: "1rem", // Font size for the input
           padding: "16px 12px" // Padding for better appearance
           }
           }}
           FormHelperTextProps={{
           style: { fontSize: "0.875rem" } // Custom styles for helper text
           }}
           sx={{
           "& .MuiOutlinedInput-root": {
           "& .MuiOutlinedInput-notchedOutline": {
           borderColor: companyNameError ? "red" : "#A0A0A0", // Border color on error
           },
           "&:hover .MuiOutlinedInput-notchedOutline": {
           borderColor: companyNameError ? "red" : "black", // Hover border color
           },
           "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
           borderColor: companyNameError ? "red" : "black", // Focus border color
           }
           },
           "& .MuiInputLabel-root": {
           color: companyNameError ? "red" : "#A0A0A0", // Label color based on error
           "&.Mui-focused": {
           color: companyNameError ? "red" : "black" // Focused label color
           }
           }
           }}
           />


                     </div>

                     <div>
                       <label className="block text-lg font-medium" style={{
                         fontSize: "1.25rem", fontWeight: "500", color: "gray-200",
                       }}>
                         <span>
                           Role
                           <span className="pl-1 text-red-600">*</span>

                         </span>
                       </label>
                     
                     <TextField
           error={!!roleError} // Error prop triggers error styles
           id="outlined-error"
           placeholder={roleError ? "Mandatory field" : "Enter Role"} // Dynamic label based on error
           value={role}
           onChange={(e) => {
           const value = e.target.value;

           setRole(value);

           setRoleError(''); // Clear error on valid input
           }}
           variant="outlined"
           fullWidth
           inputProps={{
           style: {
           fontSize: "1rem", // Font size for the input
           padding: "16px 12px", // Padding for better appearance,
           
           }
           }}
           FormHelperTextProps={{
           style: { fontSize: "0.875rem" } // Custom styles for helper text
           }}
           sx={{
           "& .MuiOutlinedInput-root": {
           "& .MuiOutlinedInput-notchedOutline": {
           borderColor: roleError ? "red" : "#A0A0A0", // Border color on error
           },
           "&:hover .MuiOutlinedInput-notchedOutline": {
           borderColor: roleError ? "red" : "black", // Hover border color
           },
           "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
           borderColor: roleError ? "red" : "black", // Focus border color
           }
           },
           "& .MuiInputLabel-root": {
           color: roleError ? "red" : "#A0A0A0", // Label color based on error
           "&.Mui-focused": {
           color: roleError ? "red" : "black" // Focused label color
           }
           }
           }}
           />


                     </div>



                   </div>


                   <div className="modal-content mt-2 gap-2 grid grid-cols-1">

<div>

 <label className="block text-lg font-medium" style={{
   fontSize: "1.25rem", fontWeight: "500", color: "gray-200"
 }}>
   
   <span>
 Highest Education
     <span className="pl-1 text-red-600">*</span>


   </span>
  
   </label>
   
<TextField

error={!!eduError} // Error prop triggers error styles
           id="outlined-error"
           placeholder={eduError ? "Mandatory field" : "Enter Highest Education"} // Dynamic label based on error

value={edu}
onChange={(e) => {
const value = e.target.value;

setEdu(value);
setEduError('');
}}
variant="outlined"
fullWidth
inputProps={{
style: {
fontSize: "1rem", // Font size for the input
padding: "16px 12px" // Padding for better appearance
}
}}
FormHelperTextProps={{
style: { fontSize: "0.875rem" } // Custom styles for helper text
}}
sx={{
  "& .MuiOutlinedInput-root": {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: eduError ? "red" : "#A0A0A0", // Border color on error
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: eduError ? "red" : "black", // Hover border color
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: eduError ? "red" : "black", // Focus border color
    }
  },
  "& .MuiInputLabel-root": {
    color: eduError ? "red" : "A0A0A0", // Label color based on error
    "&.Mui-focused": {
      color: eduError ? "red" : "black" // Focused label color
    }
  }
}}
/>


</div>
</div>



</>
        )}


  </div>


                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingTop: "20px"
                  }}
                >
                  <button
                    onClick={closeModal}
                    style={{
                      padding: "6px 20px",
                      backgroundColor: "#007BFF",
                      color: "white",
                      border: "none",
                      cursor: "pointer",
                      borderRadius: "5px",
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      

      <Footer />

    </>
  );
};

export default MainModal;
